<template>
  <div class="games transfer__wrapper">
    <form-layout
      :main-title="$t('superPass.purchase.title')"
      :small-title="true"
      :title="$t('superPass.games.title')"
      @back="$router.push('/')"
      @submit="changeModal"
    >
      <template #sub-title>
        <div class="transfer__form__subtitle">
          {{ $t('superPass.games.subTitle') }}
          <a href="#" @click.prevent="openChat">
            {{ $t('superPass.games.support') }}
          </a>
        </div>
      </template>
      <div class="transfer__form">
        <Input v-model="search" :placeholder="$t('superPass.games.placeholder')" icon="/base/search.svg" type="text" />
        <div class="transfer__form-games-list">
          <Loader v-if="isLoadedTransfer" />
          <template v-else-if="gamesList.length">
            <div v-for="game in gamesList" :key="game.id" @click="selectGame(game)">
              <GameCard :game="game" :current="currentGame" />
            </div>
          </template>
          <EmptyListInfo v-else>
            <template #text>
              {{ $t('superPass.empty.game') }}
            </template>
            <template #footer>
              <span class="link" @click="openChat">{{ $t('superPass.empty.gameLink') }}</span>
            </template>
          </EmptyListInfo>
        </div>
        <Input class="transfer__form-search-input" v-if="isShowSearch" type="text" v-model="search" :light="true" />
      </div>
    </form-layout>
  </div>
</template>

<script>
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import GameCard from '@/components/GameCard/GameCard.vue'

import { openChat } from '@/utils/chat'
import { isWithinWorkingHoursPass } from '@/utils/superPassWorkingHours'

import Input from '@/components/Base/Input/Input.vue'
import EmptyListInfo from '@/components/EmptyListInfo/EmptyListInfo.vue'
import Loader from '@/components/LoaderBar/LoaderBar.vue'

export default {
  name: 'SuperPassGames',
  components: {
    Loader,
    EmptyListInfo,
    Input,
    GameCard,
    FormLayout
  },
  data() {
    return {
      isLoadedTransfer: false,
      games: [],
      currentGame: {},
      isShowSearch: false,
      search: ''
    }
  },
  mounted() {
    /* const isTimeValid = this.isWithinWorkingHoursPass()

    if (!isTimeValid) {
      this.$emit('changeModal', {
        modal: 'SuperPassTimeInfo',
        data: []
      })
      return
    } */

    this.getGames()
  },
  computed: {
    gamesList() {
      const games = this.games

      if (this.search) {
        const search = this.search.toLowerCase()
        return games.filter(
          game =>
            game.name.toLowerCase().includes(search) ||
            game.name_en.toLowerCase().includes(search) ||
            game.tags?.includes(search)
        )
      } else {
        const sortedByOrders = games?.sort((a, b) => b.orders - a.orders)
        const top6ByOrders = sortedByOrders?.slice(0, 6)
        const others = sortedByOrders?.slice(6)
        const sortedOthersByOnline = others.sort((a, b) => b.online - a.online)

        return [...top6ByOrders, ...sortedOthersByOnline]
      }
    }
  },
  methods: {
    openChat,
    isWithinWorkingHoursPass,
    showNotification() {
      const description = this.currentGame?.in_game
        ? this.$t('superPass.games.neededGame')
        : this.$t('superPass.games.withoutGame')

      this.$store.dispatch('notification/setNotification', {
        title: this.$t('general.warning'),
        description,
        type: 'success'
      })
    },
    async changeModal() {
      if (!this.currentGame.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('superPass.errors.emptyGame'),
          type: 'error'
        })

        return
      }

      this.showNotification()

      this.$analytics.send('purch_super_1_game', {})

      this.$emit('changeModal', {
        modal: 'SuperPassPasses',
        game: this.currentGame
      })
    },

    selectGame(game) {
      this.currentGame = game
    },
    getGames() {
      this.isLoadedTransfer = true
      fetch('https://transfer.backend-pier.com/games_new')
        .then(res => res.json())
        .then(data => {
          if (data.games) {
            this.games = data.games.filter(game => game.superpass_enabled).sort((a, b) => b.online - a.online)
            this.games = this.games.map(game => {
              return {
                ...game
              }
            })
          }
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.isLoadedTransfer = false
        })
    }
  }
}
</script>

<style lang="scss">
@import './superPassGames';
</style>
